interface IconProps {
  className?: string;
}

const AlertIcon: React.FC<IconProps> = (props) => {
  return (
    <>
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className={props.className}
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 15h-2v-2h2v2Zm0-4h-2V7h2v6Z"
          className="fill-current"
        />
      </svg>
    </>
  );
};

export default AlertIcon;
